import React from 'react';
import { Input as AntdInput } from 'antd';
import { ErrorMessage, Label, Skeleton } from '../index';
import cx from 'clsx';

const { TextArea } = AntdInput;

const Input = ({
  value = '',
  placeholder = '',
  onChange = () => {},
  style,
  label = '',
  description = '',
  labelClassName = '',
  labelSize,
  containerClassName,
  errorMsg = '',
  onPressEnter = () => {},
  onBlur = () => {},
  required = false,
  suffix,
  loading = false,
  size = 'large',
  autoFocus = false,
  name = '',
  type = 'text',
  rows = null,
  disabled = false,
  inputRef,
  prefix = '',
  onFocus = () => {},
  maxLength = undefined,
  status,
}) => {
  const Component = !!rows ? TextArea : AntdInput;
  if (loading) return <Skeleton height={40} />;

  return (
    <div className={cx(containerClassName)}>
      {label && (
        <Label size={labelSize} className={labelClassName} required={required}>
          {label}
        </Label>
      )}
      <Component
        autoFocus={autoFocus}
        prefix={prefix}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        style={{ resize: 'none', ...style }}
        onBlur={onBlur}
        status={status || (errorMsg && 'error')}
        onPressEnter={onPressEnter}
        size={size}
        suffix={suffix}
        name={name}
        type={type}
        disabled={disabled}
        {...(!!rows ? { rows: rows } : {})}
        ref={inputRef}
        onKeyDown={(e) => {
          if (type === 'number' && (e.key === 'ArrowUp' || e.key === 'ArrowDown')) {
            e.preventDefault();
          }
        }}
        onWheel={(e) => {
          e.target.blur();
        }}
        onFocus={onFocus}
        maxLength={maxLength}
      />
      {description && (
        <span className="gray-500" style={{ fontSize: 12 }}>
          {description}
        </span>
      )}
      <ErrorMessage errorMsg={errorMsg} />
    </div>
  );
};

export default Input;
